module.exports = __webpack_public_path__ + "static/img/3.2.3e34271.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/3.2.png
// module id = dDTM
// module chunks = 0